"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var Utilities_1 = require("../../Utilities");
var ColorPicker_base_1 = require("./ColorPicker.base");
var ColorPicker_styles_1 = require("./ColorPicker.styles");
exports.ColorPicker = Utilities_1.styled(ColorPicker_base_1.ColorPickerBase, ColorPicker_styles_1.getStyles, undefined, { scope: 'ColorPicker' });
//# sourceMappingURL=ColorPicker.js.map